module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "world-geo-canvas-wrap"
  }, [_c('div', {
    ref: "earchStage",
    staticClass: "earch-stage"
  }), _vm._v(" "), _c('div', {
    ref: "backgroundFogStage",
    staticClass: "background-stage background-fog"
  }), _vm._v(" "), _c('div', {
    ref: "backgroundStarStage",
    staticClass: "background-stage background-stars"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d2213508!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/world-map/index.vue
// module id = 243
// module chunks = 0